import { render, staticRenderFns } from "./ThreatIndicator.vue?vue&type=template&id=545ae76d"
import script from "./ThreatIndicator.vue?vue&type=script&lang=js"
export * from "./ThreatIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports